import { FormControl, FormHelperText, InputLabel, Select, SelectProps, Theme } from '@mui/material';
import { FormikContextType } from 'formik';
import { FieldAdditionalProps } from 'shared/_ui/form/types';
import { getFieldGridSx, getFieldProps } from 'shared/_ui/form/utils';
import { deepmerge } from '@mui/utils';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';

type CommonTextFieldProps = Omit<SelectProps, 'value' | 'onChange' | 'onBlur'> &
	FieldAdditionalProps;

type FormSelectFieldProps = CommonTextFieldProps & {
	formik: FormikContextType<any>;
	readOnly?: boolean;
	onReadOnlyClick?: () => void;
	name: string;
	helperText?: string;
};

// type FieldTextFieldProps = Pick<
// 	TextFieldProps,
// 	'className' | 'name' | 'label' | 'sx' | 'fullWidth' | 'error' | 'helperText'
// > &
// 	FieldAdditionalProps & {
// 		value: ReactNode;
// 	};
//
// export function FieldSelectField(props: FieldTextFieldProps) {
// 	const { className, name, sx, label, labelProps, fullWidth, value, helperText, ...fieldProps } =
// 		props;
// 	const { error } = fieldProps;
//
// 	const sxLabel = {
// 		...(sx?.['.MuiFormLabel-root' as keyof typeof sx] ?? {}),
// 		...(labelProps?.width ? { width: labelProps.width } : {}),
// 	};
//
// 	// Use grid to move label to the correct position under the value
// 	const sxProps = deepmerge(sx ?? {}, {
// 		width: fullWidth ? '100%' : 'fit-content',
// 		...getFieldGridSx({ label, labelProps, helperText }),
// 		'.MuiFormLabel-root': {
// 			gridArea: 'label',
// 			maxWidth: '100%',
// 		},
// 		'.MuiTypography-root': {
// 			gridArea: 'value',
// 		},
// 		'.MuiFormHelperText-root': {
// 			gridArea: 'help',
// 		},
// 	});
//
// 	return (
// 		<FormControl
// 			className={cn('field', className)}
// 			sx={sxProps}
// 			fullWidth={fullWidth}
// 			{...fieldProps}
// 		>
// 			{!!label && (
// 				<InputLabel htmlFor={name} sx={sxLabel} id={`${name}-label`}>
// 					{label}
// 				</InputLabel>
// 			)}
// 			<Typography
// 				id={name}
// 				display="inline-block"
// 				width={fullWidth ? '100%' : undefined}
// 				flex={fullWidth ? 1 : undefined}
// 			>
// 				{value}
// 			</Typography>
// 			{helperText && (
// 				<FormHelperText id={`${name}-helper-text`} error={error} sx={{ flexBasis: '100%' }}>
// 					{helperText}
// 				</FormHelperText>
// 			)}
// 		</FormControl>
// 	);
// }

export function FormSelectField(props: FormSelectFieldProps) {
	const { formControlProps, formHelperTextProps, formInputLabelProps, fieldProps } =
		getFieldProps<SelectProps>(props);

	const { children, fullWidth, label, labelProps, helperText, sx } = props;

	const sxProps = deepmerge(sx ?? {}, {
		'&.field': {
			...(fullWidth ? { width: '100%' } : {}),
			...getFieldGridSx({ label, labelProps, helperText }),
		},
		'.MuiFormLabel-root': {
			gridArea: 'label',
			...(labelProps?.width ? { width: labelProps.width } : {}),
			maxWidth: '100%',
			lineHeight: '1.3',
			paddingTop: (theme) => (props.readOnly ? undefined : theme.spacing(2)),
		},
		'.MuiInputBase-input': {
			gridArea: 'value',
		},
		'.MuiFormHelperText-root': {
			gridArea: 'help',
		},
	} as SystemStyleObject<Theme>);

	return (
		<>
			<FormControl {...formControlProps} sx={sxProps}>
				{!!formInputLabelProps.children && <InputLabel {...formInputLabelProps} />}
				<Select {...fieldProps}>{children}</Select>
				{formHelperTextProps.children && <FormHelperText {...formHelperTextProps} />}
			</FormControl>
		</>
	);
}
